import React from  "react"
import { useState, useEffect, useRef} from "react"
import { Formik, Form, useField, FormikProps } from 'formik';
import * as Yup from 'yup';
import axios from "axios";
import CommonVars from "../Component/CommonVars";
import {
    Flex,
    Heading,
    Input,
    Button,  
    Stack,
    chakra,
    Box,
    Link,
    Avatar,
  } from "@chakra-ui/react";
  import { useParams } from 'react-router-dom';

 

  const MyTextField = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);
    return (
      <>
        <label>
          {label}
        </label>

        <Input {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className="error">{meta.error}</div>
        ) : null}
      </>
    );
  };


function AddReviewScreen(props){
    const [getDetails, setDetails] = useState('')
    
    useEffect(()=>{
        var form = document.querySelector("form");;
        form.addEventListener("submit", function(event){
        event.preventDefault()
        });
    }, [])
    const productId = useParams().productid

    const errRef = useRef();
    const successRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const headers = {
        "Content-Type": "application/json",
    }
    return(
        <Formik
            initialValues={{
                rating: '',
                review: ''
            }}

        validationSchema={Yup.object({
            rating: Yup.string()
            .required('Required'),
            review :Yup.string()
            .required('Review Required')
            
        })}



        onSubmit = {values =>{
            const token = localStorage.getItem('token')
            const loggedInUserID = localStorage.getItem('loggedInUserID')
            const rating = parseInt(values.rating)
            const review = String(values.review)
            console.log(loggedInUserID)
            console.log(productId)
            const Reviewbody = {
              productid : productId,
              userid : loggedInUserID,
              rating : rating,
              review :review
            }
            console.log(values)
            console.log(Reviewbody )
            axios.post(`${CommonVars.API_URL}/reviews/${productId}`, Reviewbody,{headers:{Authorization : `Bearer ${token}`} },{
                headers: headers
            })
            .then((response)=>{
                console.log(response)
                var data = response.data
                console.log(data)
                alert("Added Review")
                window.location.href='/'
            })
        }

        }
        >
                    {props => (
  <Flex
      flexDirection="column"
      width="100wh"
      height="100vh"
      backgroundColor="gray.200"
      justifyContent="center"
      alignItems="center"
    >
        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"}>{errMsg}</p> 
        <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >

        <Heading color="black.400">Add Review</Heading>
        <Box minW={{ base: "90%", md: "468px" }}>

          <Form>
            <Stack
              spacing={4}
              p="1rem"
              backgroundColor="whiteAlpha.900"
              boxShadow="md"
            >
                   <MyTextField name="rating" type="rating" label="Rating" />
                  <MyTextField name ="review" type="review" label="Review"/>
              <Button
                borderRadius={0}
                type="submit"
                variant="solid"
                colorScheme="gray"
                width="full"
              >
                                    {props.isSubmitting ? 'Adding Review...' : 'Add Reiew'}
              </Button>
            </Stack>
          </Form>

        </Box>
      </Stack>
    </Flex>
                     )}
        </Formik>
    )

}

export default AddReviewScreen;